import {
    call, put, takeEvery,
} from 'redux-saga/effects';
import { getLeadProfileDisposition } from '../../requests/get_lead_profile_request';
import { setIsErrorLeadDisposition, setIsLoadingLeadDisposition, setIsSuccessLeadDisposition } from '../actions/get_lead_disposition.actions';
import { GET_LEAD_DISPOSITION } from '../constants/get_lead_disposition.constants';

export function* getLeadDisposition(ref_lead_id) {
    yield put(setIsLoadingLeadDisposition(true));

    try {
        const dispositions = yield call(getLeadProfileDisposition, ref_lead_id);

        yield put(setIsSuccessLeadDisposition(dispositions.options));
        yield put(setIsLoadingLeadDisposition(false));
    } catch (error) {
        yield put(setIsErrorLeadDisposition(error))
        yield put(setIsLoadingLeadDisposition(false));
    }
};

export function* getLeadDispositionSaga() {
    yield takeEvery(GET_LEAD_DISPOSITION, getLeadDisposition);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/get_lead_disposition.saga.js